import { TUTORIAL_SHARING } from 'constants/tutorials';
import getTutorialCovers from './getTutorialCovers';

export default getTutorialCovers(TUTORIAL_SHARING);
